import type { DevelopmentContentFilters } from '../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { GO1_API_ROOT_URL } from '../constants';

const getDevelopmentContentFilters = (): Promise<DevelopmentContentFilters> =>
  FetchPromise.get(`${GO1_API_ROOT_URL}/content/filters`);

export const useGetDevelopmentContentFilters = () =>
  useQuery<DevelopmentContentFilters, JQuery.jqXHR>(['go1-learner-development-content-filters'], () =>
    getDevelopmentContentFilters(),
  );
